export const mapURL = {
    "fiveStarDomain":['emp5stardev.overturexl.com', 'qatestemployer5star.overturexl.com', '5staremployers.overturexl.com','5starstagingemployers.overturexl.com'],
    "lifeStyleDomain":['dynamicemployers.overturexl.com'],
    "nursesEtc":['nursesetcemployers.overturexl.com']
}
export const localHostBaseURL = 'stagingemployers.overturexl.com' 